import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { BRAND, CONTACT } from "@/data/content";

export default function ThankYou() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Richiesta ricevuta | Dentro il Calice AI Winery";
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-brand-graphite text-brand-ivory grain-overlay">
      <div className="px-4 sm:px-8 lg:px-12 py-8">
        <Link to="/" className="flex flex-col leading-none w-fit" data-testid="ty-logo">
          <span className="font-serif text-xl tracking-tight text-brand-ivory">{BRAND.name}</span>
          <span className="mt-0.5 text-[10px] uppercase tracking-editorial font-semibold text-brand-gold">
            {BRAND.division}
          </span>
        </Link>
      </div>

      <div className="flex-1 flex items-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12 py-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-brand-gold" />
              <span className="text-xs uppercase tracking-editorial font-semibold text-brand-gold">Diagnosi</span>
            </div>
            <h1 className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-brand-ivory" data-testid="ty-title">
              Richiesta ricevuta.
            </h1>
            <p className="mt-8 text-lg leading-relaxed text-brand-ivory/80 max-w-xl">
              Abbiamo ricevuto le informazioni sulla tua cantina.
            </p>
            <p className="mt-4 text-base leading-relaxed text-brand-ivory/65 max-w-xl">
              Il prossimo passo non sarà una demo commerciale standard: partiremo dal problema che hai indicato,
              per capire insieme dove esistono inefficienze, dati inutilizzati o processi migliorabili.
            </p>

            <div className="mt-10 rounded-sm border border-brand-ivory/12 bg-brand-ivory/[0.03] p-6 max-w-xl">
              <p className="font-serif italic text-xl text-brand-gold">“{BRAND.tagline}”</p>
            </div>

            {/* Contatto diretto */}
            <div className="mt-14 max-w-xl" data-testid="contact-block">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-brand-gold" />
                <span className="text-xs uppercase tracking-editorial font-semibold text-brand-gold">
                  Vuoi anticipare i tempi?
                </span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-brand-ivory/70">
                Se preferisci, scrivici subito una email: ti risponderemo partendo dal processo che ci hai indicato.
              </p>
              <div className="mt-6">
                <a
                  href={`mailto:${CONTACT.email}?subject=Richiesta%20diagnosi%20cantina`}
                  data-testid="ty-email-cta"
                  className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand-gold px-7 py-3.5 text-sm font-semibold text-brand-graphite transition-all duration-300 hover:bg-[#c9a968] hover:-translate-y-0.5"
                >
                  <Mail className="h-4 w-4" />
                  Scrivici
                </a>
                <p className="mt-3 font-mono text-xs text-brand-ivory/50">{CONTACT.email}</p>
              </div>
            </div>

            <div className="mt-10">
              <Link
                to="/"
                data-testid="ty-home-link"
                className="inline-flex items-center gap-2 rounded-full border border-brand-ivory/30 px-7 py-3.5 text-sm font-semibold text-brand-ivory transition-colors hover:border-brand-gold hover:text-brand-gold"
              >
                ← Torna alla home
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
